import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';
import { timeFormat } from 'd3-time-format';

import { PurposeProjectionQuery } from '../../graphql/purposeProjection.generated';

type PurposeType = PurposeProjectionQuery['purpose'];
export type Purpose<T extends PurposeType['__typename']> = Extract<PurposeType, { __typename: T }>;

export const formatDate = timeFormat('%b %Y');

const Root: React.FC<PropsWithChildren> = ({ children }) => (
  <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>{children}</Box>
);

const Leading: React.FC<PropsWithChildren> = ({ children }) => (
  <Box css={{ display: 'flex', flexDirection: 'column' }}>{children}</Box>
);

const Trailing: React.FC<PropsWithChildren> = ({ children }) => (
  <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>{children}</Box>
);

export const HighlightRow = Object.assign(Root, { Leading, Trailing });
